import {
  REACTION_EXCLUDE_SECTIONS,
  REACTIONS_CUTOFF_UTC,
  SHOW_REACTIONS,
} from "@config/reactions";

export function shouldShowReactions(
  publishDate: string,
  uniqueSectionName?: string,
): boolean {
  if (!SHOW_REACTIONS) return false;

  // Defined cutoff: 2025-08-29 14:30 SGT == 2025-08-29 06:30 UTC
  const cutoff = new Date(REACTIONS_CUTOFF_UTC);
  const createdDate = new Date(publishDate);

  // If article is older than cutoff, hide reactions
  if (createdDate < cutoff) return false;

  if (!uniqueSectionName) return true; // no section to check

  return !REACTION_EXCLUDE_SECTIONS.includes(uniqueSectionName.toLowerCase());
}
